import { ALERT_VARIANTS } from './constants';

// ----------------------------------------------------------------------------

function getVariantClasses(): string {
    return ALERT_VARIANTS.map((variant): any => 'alert-' + variant).join(' ');
}

// ----------------------------------------------------------------------------

export default getVariantClasses;
